import {useFlag} from '@unleash/proxy-client-react';

const useShopPersonalizedRecommendationsFlag = () =>
  useFlag('shop-personalized-recommendations');

export default useShopPersonalizedRecommendationsFlag;
